import { slugify } from '@cc-shopping/utils/string/slugify';
import type { StructuredContent, StructuredContentDocument } from '../../types';
import { getAllChildrenStrings, isStructuredContent } from '../../utils';

type ContentHeading = {
  id: string;
  header: string;
};

export const getChildrenHeadings = (parentDocument: StructuredContentDocument) => {
  const contentHeadings: ContentHeading[] = [];

  const isHeadingSCNode = (node: StructuredContent) =>
    isStructuredContent(node) &&
    ['EnhancedContentHeading', 'ContentHeading'].includes(node.type) &&
    node.props.level === 2;

  const findContentHeadings = (doc: StructuredContentDocument) => {
    const children = doc.props.children;

    // The headings are on CreditCardsTableOfContents and CreditCardsTableOfContentsSection node tree
    if (Array.isArray(children)) {
      // If one of the children is an heading, get and do not check anything else
      const headingSC = children.find(child => isHeadingSCNode(child));

      if (headingSC && isStructuredContent(headingSC)) {
        const childrenString = getAllChildrenStrings(headingSC);
        contentHeadings.push({
          id: getHeadingId(childrenString),
          header: childrenString,
        });
      } else {
        children.forEach(child => {
          if (isStructuredContent(child)) {
            findContentHeadings(child);
          }
        });
      }
    }
    if (isStructuredContent(children) && isHeadingSCNode(children)) {
      const headingSC = children;
      const childrenString = getAllChildrenStrings(headingSC);
      const id = getHeadingId(childrenString);
      contentHeadings.push({
        id,
        header: childrenString,
      });
    }

    return contentHeadings;
  };

  return findContentHeadings(parentDocument);
};

export const getHeadingId = (childrenString: string): string => slugify(childrenString);

export const getChildHeadingId = (doc: StructuredContentDocument) => {
  const heading = getChildrenHeadings(doc)[0];
  return heading.id;
};

export const COMPONENT_ID_DESKTOP = 'table-of-contents-desktop';
export const COMPONENT_ID_MOBILE = 'table-of-contents-mobile';
